<div>
  <app-language-template [onStartUp]="true" (continue)="onContinue($event)"></app-language-template>
</div>
